// extracted by mini-css-extract-plugin
module.exports =  {"container":"QxdQ832F","heading":"aXdnrtpA","list":"sYxSb9VL","item":"mt_Dl3IT","learnMore":"CDWIRYoz"};